import UrlRegExp from "./url-regex";

// TODO Should we consider trim to be an optional argument?
// TODO Should work for non-string values.
export class ValidationRules {
    /**
     * Function to validate that the value is required.
     *
     * @param value string | number - The value to test
     * @return boolean
     */
    public static required(value: string | number): boolean {
        if (typeof value === "string") {
            return value != null && value.trim() !== "";
        }
        else {
            return value != null;
        }
    }

    /**
     * Function to validate that the value is minLength.
     * Allows for null/undefined values.
     *
     * @param value string - The value to test
     * @param length number - The length allowed
     * @return boolean
     */
    public static minLength(value: string, length: number): boolean {
        return value == null || value.trim().length >= length;
    }

    /**
     * Function to validate that the value is maxLength.
     * Allows for null/undefined values.
     *
     * @param value string - The value to test
     * @param length number - The length allowed
     * @return boolean
     */
    public static maxLength(value: string, length: number): boolean {
        return value == null || value.trim().length <= length;
    }

    /**
     * Function to validate that the value is a valid email.
     * Allows for empty/null/undefined values.
     *
     * @param value string - The value to test
     * @return boolean
     */
    public static email(value: string): boolean {
        const re1 = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?/;
        const re2 = /(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        const re = new RegExp(re1.source + re2.source);
        return value == null || value.trim() === "" || re.test(value.trim());
    }

    /**
     * Function to validate that the value is of min length.
     * Allows for null/undefined values.
     *
     * @param value number - The value to test
     * @param length number - The length allowed
     * @return boolean
     */
    public static min(value: number, length: number): boolean {
        return value == null || value >= length;
    }

    /**
     * Function to validate that the value is of max length.
     * Allows for null/undefined values.
     *
     * @param value number - The value to test
     * @param length number - The length allowed
     * @return boolean
     */
    public static max(value: number, length: number): boolean {
        return value == null || value <= length;
    }

    /**
     * Function to validate that the value matches the given pattern.
     * Allows for empty/null/undefined values.
     *
     * @param value string - The value to test
     * @param pattern number - The pattern allowed
     * @return boolean
     */
    public static pattern(value: string, pattern: RegExp): boolean {
        return value == null || value.trim() === "" || pattern.test(value.trim());
    }

    /**
     * Function to validate that the value is equalTo the given match.
     * Allows for empty/null/undefined values.
     *
     * @param value string | number - The value to test
     * @param match string | number - The allowed value
     * @return boolean
     */
    public static equalTo(value: string | number, match: string | number): boolean {
        return value == null ||
            (typeof value === "number" && value === match) ||
            (typeof value === "string" &&
                (value.trim() === "" || value.trim() === match));
    }

    /**
     * Function to validate that the value is oneOf the given matches.
     * Allows for empty/null/undefined values.
     *
     * @param value string | number - The value to test
     * @param matches string[] | number[] - The allowed values
     * @return boolean
     */
    public static oneOf(value: string | number, matches: string[] | number[]): boolean {
        return value == null ||
            (typeof value === "number" && (matches as number[]).indexOf(value) >= 0) ||
            (typeof value === "string" &&
                (value.trim() === "" || (matches as string[]).indexOf(value.trim()) >= 0));
    }

    /**
     * Function to validate that the value is a valid url.
     * Allows for null/undefined values.
     *
     * @param value string - The value to test
     * @return boolean
     */
    public static url(value: string): boolean {
        return value == null || value.trim() === "" || UrlRegExp.test(value.trim());
    }
}
